<template>
  <div>
    <div class="d-flex justify-content-between">
      <div class="d-flex col-sm-5 pl-0">
        <documents-templates-modal
          template-type="operation"
          file-upload-url="woodware/generate_excel_to_movements/"></documents-templates-modal>
        <b-btn variant="outline-secondary" title="Print documents" class="d-inline-flex" size="sm"
               @click="openTemplatesModal">
          <icon name="print"></icon>
        </b-btn>
        <multiselect v-model="template" :max-height="200" class="ml-3"
                     placeholder="" label="name" track-by="name"
                     :options="operationsGridTemplates" :multiple="false"
                     :close-on-select="true" @input="applyTemplate"
                     :disabled="!operations.length"
                     select-label="" deselect-label="" selected-label=""
        ></multiselect>
        <div class="button-group d-flex" style="margin-left: 15px;">
          <b-btn size="sm" title="Create new template" style="margin-left: 0" :disabled="!operations.length"
                 @click="createTemplate">
            {{$t('buttons.common.create')}}
          </b-btn>
          <b-btn size="sm" title="Delete selected template" variant="outline-danger"
                 :disabled="!operations.length || !template" @click="deleteSelectedTemplate">
            {{$t('buttons.common.delete')}}
          </b-btn>
          <b-btn size="sm" title="Update selected template" variant="outline-success"
                 :disabled="!operations.length || !template" @click="updateSelectedTemplate">
            {{$t('buttons.common.update')}}
          </b-btn>
        </div>
      </div>
      <div class="d-flex justify-content-between button-group">
        <scanner-export-modal></scanner-export-modal>
        <b-btn variant="primary" size="sm" title="Add purchase invoice"
               v-if="permissionsList.purchase_invoices.change_purchaseinvoice" @click="addPurchaseInvoice">
          {{$t('buttons.purchase_invoices.add_purchase_invoice')}}
        </b-btn>
        <b-btn size="sm" variant="success" @click="completeOperations" title="Complete selected operations"
               :disabled="!operations.length">
          {{$t('buttons.operations.complete')}}
        </b-btn>
        <b-btn size="sm" variant="outline-secondary" @click="openScannerExportModal">
          {{$t('buttons.operations.export_from_scanner')}}
        </b-btn>
        <img src="@/assets/images/common-icons/icon_create.svg" @click="createOperation"
             title="Create operation">
        <img src="@/assets/images/common-icons/icon_clear.png" @click="cleanFilters"
             :title="$t('buttons.common.clear_filters')">
        <img src="@/assets/images/common-icons/icon_search.svg" @click="search"
             :title="$t('buttons.common.search')">
      </div>
    </div>
    <div class="search-form">
      <div class="search-form__filters">
        <b-row>
          <b-col>
            <label>{{$t('labels.operations.operation_status')}}</label>
            <multiselect v-model="searchData.status" :max-height="200"
                         placeholder="" label="text" track-by="text"
                         :options="statuses" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.name')}}</label>
            <input class="form-control" v-model="searchData.name" @keyup.enter="search">
          </b-col>
          <b-col>
            <label>{{$t('labels.common.executor')}}</label>
            <multiselect v-model="searchData.executors" :max-height="200"
                         placeholder="" label="username" track-by="id"
                         :options="users" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.order')}}</label>
            <input class="form-control" v-model="searchData.salesorder_descriptor">
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{$t('labels.common.period')}}</label>
            <multiselect v-model="searchData.period" :max-height="200" :searchable="true"
                         placeholder=""
                         label="name" track-by="name"
                         :options="periods"
                         @select="selectPeriod"
                         select-label="" deselect-label="" selected-label=""
            ></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.operations.operation_type')}}</label>
            <multiselect v-model="searchData.process" :max-height="200"
                         placeholder="" label="name" track-by="name"
                         :options="processes" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""
            ></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.supplier')}}/{{$t('labels.common.buyer')}}</label>
            <multiselect v-model="searchData.distributor" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="partners" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.carrier')}}</label>
            <multiselect v-model="searchData.carrier" :max-height="200"
                         placeholder="" label="name" track-by="id"
                         :options="carriers" :multiple="false"
                         :close-on-select="true"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>{{$t('labels.common.period_of_time')}}</label>
            <range-date-picker v-model="searchData.rangeDate" range lang="en"
                               placeholder=""
                               range-separator="/" :first-day-of-week="1"></range-date-picker>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.production_place')}}</label>
            <multiselect v-model="searchData.wobject" :max-height="200"
                         placeholder="" label="name" track-by="name"
                         :options="production_places" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
          <b-col>
            <label>{{$t('labels.common.transport_nr')}}</label>
            <input class="form-control" v-model="searchData.transport">
          </b-col>
          <b-col>
            <label>CMR</label>
            <input class="form-control" v-model="searchData.CMR">
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3">
            <label>{{$t('labels.common.stock')}}</label>
            <multiselect v-model="searchData.stock_addresses" :max-height="200"
                         placeholder="" label="name" track-by="name"
                         :options="stock_addresses" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
          <b-col cols="3">
            <label>{{$t('labels.common.delivery_address')}}</label>
            <multiselect v-model="searchData.delivery_addresses" :max-height="200"
                         placeholder="" label="name" track-by="name"
                         :options="delivery_addresses" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
          <b-col cols="3">
            <label>{{$t('labels.common.container_nr')}}</label>
            <input class="form-control" v-model="searchData.container_number">
          </b-col>
          <b-col>
            <label>{{$t('labels.common.creator')}}</label>
            <multiselect v-model="searchData.user" :max-height="200"
                         placeholder="" label="username" track-by="id"
                         :options="users" :multiple="true"
                         :close-on-select="false"
                         select-label="" deselect-label="" selected-label=""></multiselect>
          </b-col>
        </b-row>
      </div>
    </div>
    <b-row>
      <b-col class="d-flex justify-content-start align-items-center">
        <span v-for="item in totalData" :key="item.text" class="total-info__item">
          {{$t(`labels.common.${item.label}`)}}: {{item.value.toLocaleString('ru-RU')}}
        </span>
      </b-col>
      <b-col class="d-flex justify-content-end align-items-center">
        <span v-for="item in selectedData" :key="item.text" class="selected-info__item">
          {{$t(`labels.common.${item.label}`)}}: {{item.value.toLocaleString('ru-RU')}}
        </span>
        <save-columns-btn :grid="gridOptions" :grid-name="gridName" class="margin-left-5"></save-columns-btn>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <ag-grid-vue class="ag-theme-balham grid" :gridOptions="gridOptions"
                     :style="gridHeight"
                     :rowData="operations" :columnDefs="columns"
                     @selectionChanged="selectionChangedOperations"
                     @filterModified="filterModified" @rowDoubleClicked="redirectToOperation"
                     :postProcessPopup="postProcessPopup" :gridReady="search">
        </ag-grid-vue>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';
  import { AgGridVue } from 'ag-grid-vue';
  import RangeDatePicker from 'vue2-datepicker';
  import Multiselect from 'vue-multiselect';

  import {
    cleanFilters,
    saveFilters,
    setFilters,
    checkSavedFilterData,
    getArrayByProperty,
    handlerResponse,
    setNotifyData,
    transformDateFromDateRangeToStringFormatByIndex,
    sumTotalData,
    getFilteredNodes,
    getFilteredSelectedNodes
  } from '@/helpers/commonHelpers';
  import { notificationsRenderer, autoResize } from '@/helpers/renderHelpers';
  import ScannerExportModal from '@/components/modals/ScannerExportModal';
  import DocumentsTemplatesModal from '@/components/modals/DocumentsTemplatesModal';
  import SaveColumnsBtn from '@/components/common/SaveColumnsBtn';
  import { gridMixins } from '@/mixins';

  export default {
    mixins: [gridMixins],
    components: {
      RangeDatePicker,
      Multiselect,
      'ag-grid-vue': AgGridVue,
      ScannerExportModal,
      DocumentsTemplatesModal,
      SaveColumnsBtn
    },
    data() {
      return {
        statuses: [
          {key: 'A', text: this.$i18n.t('selects.operations.active')},
          {key: 'C', text: this.$i18n.t('selects.operations.history')},
          {key: 'P', text: this.$i18n.t('selects.operations.not_approved')}
        ],
        pagination: {
          index: 1,
          limit: 20,
          offset: 0
        },
        selectedData: [
          {
            label: 'selected_operations',
            value: 0
          },
          {
            label: 'from_stock_m3',
            value: 0,
            key: 'from_stock_m3'
          },
          {
            label: 'to_stock_m3',
            value: 0,
            key: 'to_stock_m3'
          }
        ],
        searchData: {
          status: [],
          name: '',
          executors: [],
          user: [],
          salesorder_descriptor: '',
          rangeDate: [],
          period: null,
          process: [],
          distributor: [],
          carrier: null,
          wobject: [],
          transport: '',
          CMR: '',
          stock_addresses: [],
          delivery_addresses: [],
          container_number: ''
        },
        defaultGridTemplate: {
          params: [],
          filters: {}
        },
        template: null,
        gridNameForTemplates: 'operations_search',
        storageKey: 'operations'
      }
    },
    methods: {
      prepareData() {
        return {
          status: getArrayByProperty(this.searchData.status, 'key').toString(),
          name: this.searchData.name,
          executors: getArrayByProperty(this.searchData.executors, 'id').toString(),
          user: getArrayByProperty(this.searchData.user, 'id').toString(),
          salesorder_descriptor: this.searchData.salesorder_descriptor,
          process: getArrayByProperty(this.searchData.process, 'id').toString(),
          distributor: getArrayByProperty(this.searchData.distributor, 'id').toString(),
          carrier: this.searchData.carrier && this.searchData.carrier.id,
          start_date_between_after: transformDateFromDateRangeToStringFormatByIndex(this.searchData.rangeDate, 0),
          start_date_between_before: transformDateFromDateRangeToStringFormatByIndex(this.searchData.rangeDate, 1),
          wobject: getArrayByProperty(this.searchData.wobject, 'id').toString(),
          transport: this.searchData.transport,
          CMR: this.searchData.CMR,
          stock_addresses: getArrayByProperty(this.searchData.stock_addresses, 'id').toString(),
          delivery_addresses: getArrayByProperty(this.searchData.delivery_addresses, 'id').toString(),
          container_number: this.searchData.container_number
        }
      },
      setDefaultGridTemplate() {
        if (this.gridOptions && this.gridOptions.columnApi && this.gridOptions.api) {
          this.defaultGridTemplate.params = this.gridOptions.columnApi.getColumnState();
          this.defaultGridTemplate.filters = this.gridOptions.api.getFilterModel();
        }
      },
      setDefaultFilters() {
        this.searchData.status = this.statuses.filter(item => item.key === 'A');
      },
      applyTemplate(currentTemplate) {
        if (currentTemplate) {
          this.gridOptions.columnApi.setColumnState(currentTemplate.params);
          this.gridOptions.api.setFilterModel(currentTemplate.filters);
        } else {
          this.gridOptions.columnApi.setColumnState(this.defaultGridTemplate.params);
          this.gridOptions.api.setFilterModel(this.defaultGridTemplate.filters);
        }
        this.$nextTick(() => {
          autoResize(this.gridOptions);
        })
      },
      prepareDialog() {
        return {
          title: this.$i18n.t(`text_content.creating_grid_template`),
          input: 'text',
          inputPlaceholder: this.$i18n.t(`placeholders.enter_grid_template_name`),
          showCancelButton: true,
          cancelButtonText: this.$i18n.t(`buttons.common.cancel`)
        }
      },
      createTemplate() {
        this.$swal.fire(this.prepareDialog()).then(result => {
          const templateName = result.value;
          if (templateName) {
            const params = this.gridOptions.columnApi.getColumnState(),
              name = templateName, filters = this.gridOptions.api.getFilterModel(),
              grid_name = this.gridNameForTemplates;
            const savedData = {params, name, grid_name, filters};
            this.$http.post(`generic/pivot_grid_table_templates/`, savedData).then(handlerResponse).then((response) => {
              const templateName = response.name;
              this.$notify(setNotifyData(this.$i18n.t(`notifications.common.grid_template_created`, {templateName}), '',
                'success'));
              this.$store.dispatch('generic/getGridTemplates', this.gridNameForTemplates);
            }).catch(error => notificationsRenderer(error.data, 'error'));
          }
        });
      },
      deleteSelectedTemplate() {
        const templateId = this.template.id, templateName = this.template.name;
        this.$http.delete(`generic/pivot_grid_table_templates/${templateId}/`).then(() => {
          this.template = null;
          this.$notify(setNotifyData(this.$i18n.t(`notifications.common.grid_template_deleted`, {templateName}), '',
            'success'));
          this.$store.dispatch('generic/getGridTemplates', this.gridNameForTemplates);
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      updateSelectedTemplate() {
        const templateId = this.template.id, templateName = this.template.name,
          params = this.gridOptions.columnApi.getColumnState(),
          grid_name = this.gridNameForTemplates, filters = this.gridOptions.api.getFilterModel();
        const savedData = {grid_name, filters, params};
        this.$http.put(`generic/pivot_grid_table_templates/${templateId}/`, savedData).then(() => {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.common.grid_template_updated`, {templateName}), '',
            'success'));
          this.$store.dispatch('generic/getGridTemplates', this.gridNameForTemplates);
        }).catch(error => notificationsRenderer(error.data, 'error'));
      },
      completeOperations() {
        const operations = getFilteredSelectedNodes(this.gridOptions).map(item => item.data.id);
        if (operations.length) {
          this.$http.post(`woodware/complete_operations/`, {operations}).then(handlerResponse).then((response) => {
            const type = response.fully_succeeded ? 'success' : 'warn';
            this.$notify(setNotifyData(response.message, '', type));
            this.search();
          }).catch(error => notificationsRenderer(error.data, 'error'));
        } else {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.operations.select_to_complete`), '', 'warn'));
        }
      },
      addPurchaseInvoice() {
        const relatedAcceptancesData = getFilteredSelectedNodes(this.gridOptions)
          .filter(({data}) => data.process === 'Priemimas' && data.status === 'P' && !data.purchase_invoice_number) // Acceptances with status Not approved without bounded purchase invoice
          .map(item => item.data);
        const movement_id = relatedAcceptancesData.map(item => item.id).toString();
        if (movement_id) {
          const contract = relatedAcceptancesData[0].contract_nr;
          const supplier = relatedAcceptancesData[0].distributor_name;
          const receiving_date = relatedAcceptancesData[0].end_date;
          this.$router.push({
            name: 'Purchase Invoice',
            params: {
              id: 'new',
              contract,
              supplier,
              receiving_date,
              movement_id
            }
          });
        } else {
          this.$notify(
            setNotifyData(this.$i18n.t(`notifications.operations.select_not_bounded_acceptances_in_not_approved_status`),
              '', 'warn'));
        }
      },
      createOperation() {
        this.$router.push({path: `/operation/new`});
      },
      async search() {
        // this.gridOptions.api.showLoadingOverlay();
        const params = this.prepareData();
        this.selectedData = sumTotalData([], this.selectedData);
        try {
          await this.$store.dispatch('operations/loadOperations', params);
          if (this.template) {
            this.applyTemplate(this.template);
          } else {
            this.setDefaultGridTemplate();
          }
          saveFilters(this.storageKey, this.searchData);
        } finally {
          this.gridOptions.api.hideOverlay();
        }
      },
      cleanFilters() {
        cleanFilters(this.searchData, this.storageKey);
        this.setDefaultFilters();
      },
      selectPeriod(currentPeriod) {
        this.searchData.rangeDate = [currentPeriod.date_start, currentPeriod.date_end];
      },
      selectionChangedOperations() {
        const selectedOperations = this.gridOptions.api.getSelectedRows();
        this.selectedData = sumTotalData(selectedOperations, this.selectedData);
      },
      filterModified() {
        const filteredData = getFilteredNodes(this.gridOptions).map(item => item.data);
        this.$store.commit('operations/setTotalData', filteredData);
        this.gridOptions.api.deselectAll();
      },
      openScannerExportModal() {
        this.$root.$emit('openScannerExportModal');
      },
      openTemplatesModal() {
        const movement_ids = getFilteredSelectedNodes(this.gridOptions).map(item => item.data.id);
        if (movement_ids.length) {
          this.$root.$emit('openDocumentsTemplatesModal', {movement_ids: movement_ids.toString()});
        } else {
          this.$notify(setNotifyData(this.$i18n.t(`notifications.operations.select_to_download`), '', 'warn'));
        }
      },
      redirectToOperation(params) {
        if (params.data && params.data.id) {
          this.$router.push({path: `/operation/${params.data.id}`});
        }
      }
    },
    computed: {
      ...mapGetters('woodware', ['periods', 'stock_addresses', 'processes', 'production_places', 'delivery_addresses',
        'users', 'partners', 'carriers']),
      ...mapGetters('operations', ['gridOptions', 'operations', 'columns', 'totalData']),
      ...mapState('operations', ['gridName']),
      ...mapState('generic', ['operationsGridTemplates']),
      ...mapState('generic', ['permissionsList']),
      gridHeight() {
        return {height: 'calc(100vh - 400px)'};
      }
    },
    beforeMount() {
      this.setDefaultFilters();
      this.$store.cache.dispatch('woodware/getPeriods');
      this.$store.cache.dispatch('woodware/getProcesses');
      this.$store.cache.dispatch('woodware/getProductionPlaces');
      this.$store.cache.dispatch('woodware/getUsers');
      this.$store.dispatch('woodware/getDeliveryAddresses');
      this.$store.dispatch('woodware/getPartners', {is_active: true});
      this.$store.cache.dispatch('woodware/getStockAddresses');
      this.$store.dispatch('generic/getGridTemplates', this.gridNameForTemplates);
      if (checkSavedFilterData(this.storageKey)) {
        this.searchData = setFilters(this.storageKey);
      }
      this.search();
    },
    beforeDestroy() {
      this.$store.commit('operations/setData', {data: [], grid_name: ''});
      this.$store.commit('operations/setTotalData', []);
    },
    watch: {
      'pagination.index': {
        immediate: false,
        handler () {
          this.pagination = {
            ...this.pagination,
            offset: (this.pagination.index - 1) * this.pagination.limit
          };
          this.search()
        }
      }
    }
  }
</script>

<style scoped>
  .grid {
    height: calc(100vh - 400px);
  }

  .total-info__item, .selected-info__item {
    font-weight: bold;
    font-size: 13px;
  }

  .total-info__item {
    margin-right: 8px;
    color: red;
  }

  .selected-info__item {
    margin-left: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/modules/manufacture/operations/Operations.vue